import React from 'react';
import { Layout } from '~common/Layout';
import { PageLayout } from '~common/PageLayout';
import { StandardCard } from '~common/UI';
import { DiamondHandsPage } from '~features/diamondHands';
import { DiamondHandsFAQ } from '~features/faq/DiamondHandsFAQ';

export default function DiamondHands() {
  return (
    <Layout navbarVisibility={{ levels: false }}>
      <PageLayout
        title="Diamond Hands"
        links={[
          {
            name: 'Staking dashboard',
            href: '/levels',
          },
        ]}>
        <DiamondHandsPage />
        <section className="py-12">
          <StandardCard>
            <DiamondHandsFAQ />
          </StandardCard>
        </section>
      </PageLayout>
    </Layout>
  );
}
